import CryptoJS from "crypto-js";
import { JSEncrypt } from "jsencrypt";
import { Base64 } from "js-base64";
import CryptoJSConfig from "./config";

/**
 * aes加密
 */
const IV = "0000000000000000";
/**
 * RES加密
 * @param {String} str 要加密的数据
 * @param {String} key RES加密密钥
 */
export function aesEncrypt(str, key) {
  key = padLeft(key, 32, "0"); // key不足32位，左填充0
  const _key = CryptoJS.enc.Utf8.parse(key);
  const srcs = CryptoJS.enc.Utf8.parse(str);
  const encrypted = CryptoJS.AES.encrypt(srcs, _key, {
    iv: CryptoJS.enc.Utf8.parse(IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString();
}
/**
 * RES解密
 * @param {String} str 要解密的数据
 * @param {String} key RES加密密钥
 */
export function aesDecrypt(str, key) {
  key = padLeft(key, 32, "0"); // key不足32位，左填充0
  const _key = CryptoJS.enc.Utf8.parse(key);
  const encryptedHexStr = CryptoJS.enc.Hex.parse(str);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, _key, {
    iv: CryptoJS.enc.Utf8.parse(IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
}
// 补位
function padLeft(value, total, pad) {
  return (Array(total).join(pad || 0) + value).slice(-total);
}

/**
 * rsa加密
 */

const Encrypt = new JSEncrypt({});

/**
 * RSA加密
 * @param {String} msg 要加密的数据
 * @param {String} key RSA加密密钥
 */
const rsaEncry = (msg, key) => {
  Encrypt.setPublicKey(key);
  return Encrypt.encrypt(msg);
};

/**
 * RSA解密
 * @param {String} msg 要解密的密文
 * @param {String} key RSA解密密钥
 */

const rsaDecry = (msg, key) => {
  Encrypt.setPrivateKey(key);
  return Encrypt.decrypt(msg);
};

// 获取时间戳+sign加密
export function getTimestamp(isEncrypt) {
  const timestamp = String(new Date().getTime());
  let sign: any = "";
  // console.log("kry==", CryptoJSConfig.CryptoJSData.publicKey);
  const publicKey = CryptoJSConfig.CryptoJSData.publicKey; // RSA公钥
  if (isEncrypt) {
    // 签名字符串采用RSA加密传递后端
    sign = rsaEncry(timestamp, publicKey);
  } else {
    // 使用base加密
    sign = Base64.encode(timestamp);
  }
  return { timestamp: timestamp, sign: sign };
}

// 测试 默认的 KEY 与 iv 如果没有给
const key = CryptoJS.enc.Utf8.parse("ADMIN20190103"); // ""中与后台一样  密码
const iv = CryptoJS.enc.Utf8.parse("admin2019._+-"); // ""中与后台一样 偏移量
// 加密
export function encrypt(word) {
  const srcs = CryptoJS.enc.Utf8.parse(word);

  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return encrypted.toString();
}
// 解密
export function decrypt(word, keyStr, ivStr) {
  keyStr = keyStr || "LAXUNMAX20190103";
  ivStr = ivStr || "laxunmax2019._+-";
  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const iv = CryptoJS.enc.Utf8.parse(ivStr);

  const decrypt = CryptoJS.AES.decrypt(word, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
}
